module.exports = __webpack_public_path__ + "static/media/image2.8de6195d.jpg";